import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@e2n/ui';
import { faMessageLines } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function FristenComment({ bemerkung }: { bemerkung: string }) {
  return (
    <>
      <Popover>
        <PopoverTrigger className="flex md:hidden">
          <FontAwesomeIcon
            icon={faMessageLines}
            className="text-primary-blue-600"
          />
        </PopoverTrigger>
        <PopoverContent className={`bg-white p-2 w-60`} side="bottom">
          <span>{bemerkung}</span>
        </PopoverContent>
      </Popover>
      <Tooltip>
        <TooltipTrigger className="hidden md:flex">
          <FontAwesomeIcon
            icon={faMessageLines}
            className="text-primary-blue-600"
          />
        </TooltipTrigger>
        <TooltipContent className={`bg-white p-2 w-60`} side="bottom">
          <span>{bemerkung}</span>
        </TooltipContent>
      </Tooltip>
    </>
  );
}
